module.exports = __webpack_public_path__ + "img/adobe-vs-magento-img.c81ffe4e.jpeg";